import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/auth-module/rl-logo.svg'


const _hoisted_1 = { class: "flex bg-white h-screen" }
const _hoisted_2 = { class: "w-1/2 flex flex-col mt-[6rem] items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "w-12 h-12"
}, null, -1)
const _hoisted_4 = { class: "text-3xl font-semibold mt-5" }
const _hoisted_5 = { class: "font-normal text-base mt-1" }
const _hoisted_6 = { class: "w-[50%]" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "flex justify-center mt-6" }
const _hoisted_10 = { class: "text-sm text-gray-600 font-normal" }
const _hoisted_11 = { class: "flex h-full items-end w-full pl-5 pb-5" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("section", { class: "w-1/2 bg-gray-300" }, null, -1)

import router from "@/router";
import { ref } from "vue";
import { useUserStore } from "@/stores/userStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordView',
  setup(__props) {

const userStore = useUserStore();

const email = ref("");

const GoToLogin = () => {
  router.push("/auth/login");
};

const handleSubmit = async (value: any) => {
  await userStore.resetPassword(value.email);
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("forgot_password_view.title")), 1),
      _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("forgot_password_view.sub_title")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FormKit, {
          type: "form",
          id: "login-form",
          actions: false,
          onSubmit: handleSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              name: "email",
              type: "email",
              label: _ctx.$t('forgot_password_view.email_label'),
              validation: "required|email",
              "outer-class": "my-4 ",
              "input-class": "h-11 mt-1",
              placeholder: _ctx.$t('forgot_password_view.email_placeholder'),
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              "validation-messages": {
              required: _ctx.$t('forgot_password_view.email_required'),
              length: _ctx.$t('forgot_password_view.email_length'),
            }
            }, null, 8, ["label", "placeholder", "modelValue", "validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "submit",
              class: "w-full h-11 opacity-50 font-semibold text-base text-white rounded-[20px] mt-6",
              inputClass: "mt-4 px-6 py-[10px]",
              disabled: _unref(userStore).loader.resetPassword,
              "validation-messages": {
              required: '',
              length: '',
            }
            }, {
              default: _withCtx(() => [
                (_unref(userStore).loader.resetPassword)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("forgot_password_view.btn_resetting")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("forgot_password_view.btn_reset")), 1))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.$t("forgot_password_view.back_to_login")) + " ", 1),
            _createElementVNode("a", {
              onClick: GoToLogin,
              class: "text-sm cursor-pointer font-semibold text-blue-600"
            }, _toDisplayString(_ctx.$t("forgot_password_view.login")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", {
          class: "text-gray-600 font-normal text-sm",
          innerHTML: _ctx.$t('forgot_password_view.email')
        }, null, 8, _hoisted_12)
      ])
    ]),
    _hoisted_13
  ]))
}
}

})